export const SET_PLUGIN_MANIFEST = 'SET_PLUGIN_MANIFEST';
